// @ts-nocheck

import networkActions from '../actions/network';
import { SearchMaxLength } from '../constants/search';
import { SearchActionTypes } from '../types/actions/search';

export const search = (query) => (dispatch) => {
  const searchQuery = query.substring(0, SearchMaxLength);
  dispatch({
    type: SearchActionTypes.SET_SEARCH_QUERY,
    payload: {
      query: searchQuery,
    },
  });
  if (query.length > 1) {
    dispatch(networkActions.send({ search: searchQuery }, { debounce: { time: 250, options: { trailing: true } } }));
  }
};

export const clearSearch = () => ({
  type: SearchActionTypes.CLEAR_SEARCH,
});
